module.exports = {
  InvalidAsn1Error: function InvalidAsn1Error(msg) {
    var e = new Error();
    e.name = 'InvalidAsn1Error';
    e.message = msg || '';
    return e;
  }
};